function size_call(){
    $('.single-option-selector.size').each(function(){
      if($(this).find('option').length > 1 && $(this).find('option').val() != ''){
        $(this).prepend('<option value="" selected="">Select a size</option>');
        $(this).val('').trigger('change');
        $(this).closest('.stlpopup-wrap').find('.cart-button').addClass('disabled').attr('disabled',true);
      }
    });
  }
function cs_discount_applied_Cart() {
  if($('.csapp-price-saving').length > 0){
      var price_final = $('.csapp-price-wrapper').find('.csapps-cart-total span').html();
      $('.final_price_cart').html('('+price_final+')');
      var avoid = "$";
      var final_install = parseFloat(price_final.replace(avoid, ''));
      $('.cart_install').html((final_install/12).toFixed(3)); 
      $('.shop_look_discount').addClass('active');
      $('.final_price_minicart').html('(TOTAL '+price_final+')');
    }
}
$(document).ready(function(){  
    $('body').on('click','.add_gift',function(){
    $('.bag_add_popup').addClass('active');
  });
   $('body').on('click','.surprise-gift',function(){
    $('.bag_add_popup_gift').addClass('active');
  });
  var mainheader = $('header').outerHeight();
  $('body').css("padding-top", mainheader);
  
function related(){
  if($('.pdp_recomended_sl').length){
    var $pdp_recomended_sl = $('.pdp_recomended_sl');
   if ($(window).width() <= 1024) {
      if ($pdp_recomended_sl.hasClass('slick-initialized')) {
        $pdp_recomended_sl.slick('unslick');
      }
    } else {
      if (!$pdp_recomended_sl.hasClass('slick-initialized')) {
        $pdp_recomended_sl.slick({
          lazyLoad: 'ondemand',
          infinite: true,
          centerMode: false,
          slidesToShow: 4,
          slidesToScroll: 1,  
        });
      }
    }
  }else{
    setTimeout(function(){
      related();
    },1000);
  }
}

  
function sp_look_slider(){
  if($('.sp_look_slider').length > 0){
        var data_url = $('.sp_look_slider').attr('data-collection-url');
        $.ajax({
        url: data_url,
        type: 'get',
        success: function(data_c){
          $('.sp_look_slider').html($(data_c).closest('.main_slider').html());
          $('.sp_look_slider_nav').html($(data_c).closest('.nav_slider').html());
          if($('.sp_look_slider').find('.sp_sl_item ').length < 7){
            $('.sp_look_slider').addClass('not_drag');
          }
            $('.sp_look_slider').slick({
                infinite: false,
                slidesToShow: 6,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                 asNavFor: '.sp_look_slider_nav',
                 responsive: [
                  {
                    breakpoint: 992,
                    settings: {
                      arrows: false,
                      slidesToShow: 4
                    }
                  },
                  {
                    breakpoint: 640,
                    settings: {
                      arrows: false,
                      slidesToShow: 3
                    }
                  }
                ]
              });
            $('.sp_look_slider_nav').slick({
                infinite: false,
                slidesToShow: 6,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                focusOnSelect: true,
                asNavFor: '.sp_look_slider',
                responsive: [
                  {
                    breakpoint: 992,
                    settings: {
                      arrows: false,
                      slidesToShow: 4
                    }
                  },
                  {
                    breakpoint: 640,
                    settings: {
                      arrows: false,
                      slidesToShow: 3
                    }
                  }
                ]
              });
            var cur_pro_handle = $('.shop_the_look').attr('data-product-handle');
            $('.sp_sl_item[data-product-handle='+cur_pro_handle+']').find('.sp_look_img').addClass('active');
            var index_go = $('.sp_sl_item[data-product-handle='+cur_pro_handle+']').attr('data-slick-index');
            $('.sp_look_slider_nav').slick('slickGoTo',index_go);
            var sp_item = parseInt($('.sp_look_slider .sp_look_img').length);
            var sp_item_add = parseInt($('.sp_look_slider .sp_look_img.add_to_cart').length);
            if(sp_item == sp_item_add){
              $('.sp_inner_btn').addClass('active_btn');
              $('.sp_inner_text').removeClass('active_txt');
            }
        },
        error: function(e){
          a.remove(); 
        }
    });
  }else{
    setTimeout(function(){
      sp_look_slider();
    },1000);
  }
}
sp_look_slider();

  function sp_item_header (){
    var sp_item = parseInt($('.sp_look_slider .sp_look_img').length);
    var sp_item_add = parseInt($('.sp_look_slider .sp_look_img.add_to_cart').length);
    if(sp_item == sp_item_add){
      $('.sp_inner_btn').addClass('active_btn');
      $('.sp_inner_text').removeClass('active_txt');
    }
  }
  
  $('a.collection_filter.selected').each(function(i,v){
    if(i < 1){
      $('.all-filter-tag').find('.gender').removeClass('active');
      $('.all-filter-tag').find('.gender-content').removeClass('active');
      $(this).parents('.gender-content').addClass('active');
      var cur_tab = $(this).parents('.gender-content').attr('data-tab');
      $('.all-filter-tag').find('.gender[data-tab="'+cur_tab+'"]').addClass('active');
    }
    });
$('body').on('click','.sale-filter-inner ul.top-tab li',function(){
   var cur_tab = $(this).attr('data-tab');
   $('.sale-filter-inner ul.top-tab li,.all-filter-tag').removeClass('active'); 
    $(this).addClass('active');
    $('.all-filter-tag.'+cur_tab).addClass('active');
});
$('body').on('click','.all-filter-tag .gender',function(){
   var cur_tab = $(this).attr('data-tab');
       $(this).parents('.all-filter-tag').find('.gender-content').removeClass('active');
    $(this).parents('.all-filter-tag').find('.gender').removeClass('active');
     $(this).parents('.all-filter-tag').find('.gender-content[data-tab="'+cur_tab+'"]').addClass('active');
    $(this).addClass('active');
});
  if($('[data-fancybox]').length > 0){
    $('[data-fancybox]').fancybox({
      loop : true
    });
  }
  $.get("/cart?view=mini-cart", function(data) {
    $('body').find('.minicart-dropdown-content#cart').html(data);
  });  
//   $('.new-home-section').slick({
//     lazyLoad: 'ondemand',
//     infinite: true,
//     centerMode: false,
//     slidesToShow: 4,
//     slidesToScroll: 1,      
//     responsive: [
//       {
//         breakpoint: 992,
//         settings: {
//           slidesToShow: 3
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 2
//         }
//       }
//     ]
//   });
  
  $(window).on('load resize orientationchange', function () {

    $('.new_home_section').each(function () {
      if($('body').hasClass('template-cart')){
          var slideshow = 5;
      }else{
        var slideshow = 4;
      }
      var $new_home_section = $(this);
      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if ($(window).width() <= 1024) {
        if ($new_home_section.hasClass('slick-initialized')) {
          $new_home_section.slick('unslick');
        }
      }
      else {
        if (!$new_home_section.hasClass('slick-initialized')) {
          $new_home_section.slick({
            lazyLoad: 'ondemand',
            infinite: true,
            centerMode: false,
            slidesToShow: slideshow,
            slidesToScroll: 1, 
          });
        }
      }
    });
  });
  
  $('body').on('click','.collection-description .read-more',function(e){
    e.preventDefault();
    $('.more').hide();
    $('.less').show();
    $(this).hide();
    $('.read-less').show();
  });

  $('body').on('click','.collection-description .read-less',function(e){
    e.preventDefault();
    $('.less').hide();
    $('.more').show();
    $(this).hide();
    $('.read-more').show();
  });

  var speed_auto = parseInt($('.hero_slider').attr('data-slide-speed'));
  $('.hero_slider').slick({
    lazyLoad: 'ondemand',
    arrows:true,
    dots:false,
    infinite:true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: speed_auto,
    rtl: false
  });
  
  $('.main-menu li').hover(function(){
    var all_images = $(this).find('.mega-menu').find('.mega-menu-right li');
    $(all_images).each(function(){
      var src = $(this).find('.menu-cat-img').data('img-src');
      var img ='<img src="'+src+'" class="img-fluid" alt="img" />';
      $(this).find('.menu-cat-img').html(img);
    });
  });

  //  register page get email value 
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };

  if(getUrlParameter('email')) {
    $('#Email').val(getUrlParameter('email'));
  }

   $(window).on('load resize orientationchange', function () {
     
    function get_filter_desk(mobile_menu,desk){
      var get_url = [];
      if(mobile_menu == true){
        if(desk == 0 ){
          $('.reponsive-menu-content .mobile-menu-size .cm-filter-block-desk').each(function(){
            if($(this).find('input[type="checkbox"]:checked').length){
              $(this).find('input[type="checkbox"]:checked').each(function(){
                if(get_url.includes('filter.v.option.tamaño='+$(this).parent('li').data('handle')) != true ){
                  get_url.push('filter.v.option.tamaño='+$(this).parent('li').data('handle'));
                }
              });
            }
          });
        }else{
			$('nav .mobile-menu-size .cm-filter-block-desk').each(function(){
            if($(this).find('input[type="checkbox"]:checked').length){
              $(this).find('input[type="checkbox"]:checked').each(function(){
                if(get_url.includes('filter.v.option.tamaño='+$(this).parent('li').data('handle')) != true ){
                  get_url.push('filter.v.option.tamaño='+$(this).parent('li').data('handle'));
                }
              });
            }
          });
        }
      }else{
        $('.cm-filter-block-desk').each(function(){
          if($(this).find('input[type="checkbox"]:checked').length){
            $(this).find('input[type="checkbox"]:checked').each(function(){
              if(get_url.includes('filter.v.option.tamaño='+$(this).parent('li').data('handle')) != true ){
                get_url.push('filter.v.option.tamaño='+$(this).parent('li').data('handle'));
              }
            });
          }
        });
      }
      get_url = get_url.join('&');
      if(get_url != ''){
        var sep = '&';
      }else{
        var sep = '';
      }

       if(mobile_menu == true){
        if($('.reponsive-menu').find('.limonada-blue').length > 0){        
          window.location = '/collections/black-and-blue?filter.v.availability=1&sort_by=created-descending&' + get_url;
        }else if($('.reponsive-menu').find('.limonada-4kids').length > 0){        
          window.location = '/collections/todo-4-kids?filter.v.availability=1&sort_by=created-descending&' + get_url;
        }else{
          window.location = '/collections/limonada-chile?filter.v.availability=1&sort_by=created-descending&' + get_url;
        }
      }else{
        if(window.location.href.indexOf('black-and-blue') > 0){        
          window.location = '/collections/black-and-blue?filter.v.availability=1' + sep + get_url;
        }else if(window.location.href.indexOf('4kids') > 0){        
          window.location = '/collections/todo-4-kids?filter.v.availability=1' + sep + get_url;
        }else{
          window.location = '/collections/limonada-chile?filter.v.availability=1' + sep + get_url;
        }
      }
    }

     /*
    $('body').on("click",".collection_popup .aplly-btn a",function(e){
      e.preventDefault();
      $(this).addClass('loading');
      var mobile_menu = false;
      get_filter_desk(mobile_menu);

    })
     
     $('body').on("click",".mobile-menu-size .aplly-btn-mob-filter a",function(e){
      e.preventDefault();
      $(this).addClass('loading');
       var mobile_menu = true;
       var desk = parseInt($(this).parents('nav').length);
      get_filter_desk(mobile_menu,desk);

    });
    ;*/
  });

  $('.top-to-bottom').on('click', function() {
    $('html, body').animate({
      scrollTop: $('html, body').offset().top,
    });
  });
  
  
  //CHECK OUT MENU
  


  /* Image Zoom Starts */
  jQuery('.pro-thumb-slider').on('afterChange', function(event, slick, currentSlide){
    var newurl = $('.thumb-items.slick-current').find('a').attr('href');
    $('.zoom-caption a').attr('href', newurl);
  });
  /* Image Zoom Ends */

  function currencyFormSubmit(event) {
    event.target.form.submit();
  }

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });

  var time = 7;
  var $bar,
      $slick,
      isPause,
      tick,
      percentTime;

  $slick = $('.offer-slick-text');
  var speed_auto_t = parseInt($('.offer-slick-text').attr('data-slide-speed'));
  $slick.slick({
    draggable: true,
    adaptiveHeight: false,
    arrow: false,
    mobileFirst: true,
    pauseOnDotsHover: true,
    autoplay: true,
    autoplaySpeed: speed_auto_t,
  });

  $bar = $('.slider-progress .progress');
  $barRound = $('.progress');

  $('.top-header-slick').on({
    mouseenter: function() {
      isPause = true;
    },
    mouseleave: function() {
      isPause = false;
    }
  })

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    isPause = false;
    tick = setInterval(interval, 0);
  }
  var $rbar = $('.progress circle');
  var rlen = 3 * Math.PI * $rbar.attr('r');
  function interval() {

    percentTime += 1 / (time + 0.8);
    $bar.css({
      width: percentTime + '%'
    });
    $rbar.css({
      'stroke-dasharray': rlen,
      'stroke-dashoffset': rlen * (5 - percentTime / 150 )
    });

    if (percentTime >= 150) {
      $slick.slick('slickNext');
      startProgressbar();
    }

  }


  function resetProgressbar() {
    $bar.css({
      width: 0+'%' 
    });
    clearTimeout(tick);
  }

  startProgressbar();

  /* ------------ Cart Side Menu Starts ------------ */
  $('body').on("click",'.cart-mini',function(){
    $("body").addClass('overflow-hidden');
    $(".minicart-dropdown,.cart-overlay").addClass('active');
  });

  $('body').on("click",'.minicart-close,.cart-keep-btn-url',function(e){
    $("body").removeClass('overflow-hidden');
    $('body').find(".minicart-dropdown,.cart-overlay").removeClass('active');
    e.stopPropagation();
  });
  $('body').on('click','.cart-overlay', function(e){
    $("body").removeClass('overflow-hidden');
    $('body').find(".minicart-dropdown,.cart-overlay").removeClass('active');
    e.stopPropagation();
  });

  
  $('body').on("click",'.cart-content-btm',function(e){
    $(".sub_tl_btn .accordian-main").addClass('active');
  });
  $('body').on('click','.close_acc_popup, .acc_overlay', function(e){
    $(".sub_tl_btn .accordian-main").removeClass('active');
  });
  /* ------------ Cart Side Menu Ends ------------ */


  $(window).on('load resize orientationchange', function () {
    if ($(window).width() < 768){
      $('.filter-block-inner').on('click', function(e) {
        e.preventDefault();
        $(".left-col, body").addClass("active-sidebar");
      });
      $('body').on('click','.filter-overlay, .left-close', function(e) {
        e.preventDefault();
        $(".left-col, body").removeClass("active-sidebar");
      });
      $('body').on('click','.filter-header-inner',function(e){
        e.preventDefault();
        $(".filter-body").slideDown();
        $(this).addClass("active-filter");
        $('.mob-filter .overlay').addClass('active');
        $('.mob-filter').addClass('active');
        $('body').addClass('mob-filter-active');
      });
      $(".cm-close-filter, .overlay").on("click", function (e) {
        e.preventDefault();
        $(" body, .filter-header-inner").removeClass("active-filter");
        $(".filter-body").slideUp();
        $('.mob-filter .overlay').removeClass('active');
        $('.mob-filter').removeClass('active');
        $('body').removeClass('mob-filter-active');
      });

      // $(function () {
      //   $('.hero_marquee').infiniteslide({
      //       speed: 50,
      //       pauseonhover: false,
      //       clone: 5,
      //       direction: 'right'
      //   });
      // });
    }
  });

  /* ------------ Responsive Menu Starts ------------ */

  $('body').on('click','.mobile-menu',function(){

    $("body").addClass('overflow-hidden');
    $(".cart-overlay,.reponsive-menu").addClass('active');
    $(".reponsive-menu-close, .menu_cross").addClass('active');
  });

  $('body').on('click','.reponsive-menu-close,.cart-overlay, .menu_cross', function(e){
    $("body").removeClass('overflow-hidden');
    $(".cart-overlay,.reponsive-menu").removeClass('active');
    $(".reponsive-menu-close, .menu_cross").removeClass('active');

    e.stopPropagation();
  });

  /* ------------ Responsive Menu Ends ------------ */


  /* ------------ Cat-left Col Accordian Starts ------------ */
  $('body').on('click','.filter-block .heading',function(e) { 
    e.preventDefault(); 
    $(this).toggleClass('active');
    $(this).parent('.filter-block').toggleClass('active');
    $(this).parent('.filter-block').find('.filter-block-contnet').toggleClass('active');
    $('.left-inner .filter-block').each(function(){
      var $ps = $(this).find('.coll-filter').find("a");
      if($(this).find('.coll-filter').find("a").length > 5){
        $(this).find('.coll-filter').find(".readmore").show();
        $(this).find('.coll-filter').find(".readless").hide();
      }
      $ps.slice(5).hide();
    }); 
  });
  
  
  /*** SEARCH OPEN ****/
  
  /*** MENU MOBILE ***/
//   $("body").on('click','.acnav__label',function () {				
//     $(this).closest('ul').find("> .has-children").removeClass("is-open");				
//     $(this).closest('ul').find("> .acnav__list").slideUp();		
//     console.log(!$(this).next().is(":visible"));
//     if (!$(this).next().is(":visible")) {
//       $(this).next().slideDown();
//       $(this).closest('li').addClass("is-open");
//     }
//   });
  
  $("body").on('click','.menu-head',function () {				
    $(".menu-head").removeClass("active");				
    $(".menu-sub-content").slideUp();		
    if (!$(this).next().is(":visible")) {
      $(this).next().slideDown();
      $(this).addClass("active");
    }
  });
  
  $("body").on('click','.dropdown-sub',function () {
    var label = $(this);
    var parent = label.parent('.has-children');
    var list = label.siblings('.acnav__list');
    if (parent.hasClass('is-open')) {
      parent.removeClass('is-open');
    }
    else {
      parent.addClass('is-open');
    }
  });

  $('body').on('click','.cm_back_menu',function () {
    $(this).closest('.has-children').removeClass('is-open');
  });
  
  $(".cart-overlay, .reponsive-menu-close").on("click", function() {
    $('.reponsive-main-menu').find('.has-children').removeClass('is-open');
    $(".menu-head").removeClass("active");
    $(".menu-sub-content").slideUp();
  });
  
//   $('body').on('click','.acnav__label',function () {
//     var label = $(this);
//     var parent = label.parent('.has-children');
//     var list = label.siblings('.acnav__list');
//     if (parent.hasClass('is-open')) {
//       list.slideUp('fast');
//       parent.removeClass('is-open');
//     }
//     else {
//       list.slideDown('fast');
//       parent.addClass('is-open');
//     }
//   });
  
//    $('.acnav__label').click(function() {
//         var label = $(this);
//         var parent = label.parent('.has-children');
//         var list = label.siblings('.acnav__list');
//         if (parent.hasClass('is-open')) {
//             list.slideUp('fast');
//             parent.removeClass('is-open');
//             $("body").addClass("menu-active");
//         } else {
//             $('.mega_menu_inner').slideUp('fast');
//             $('.has-children').removeClass('is-open')
//             list.slideDown('fast');
//             parent.addClass('is-open');
//             $("body").removeClass("menu-active");
//         }
//         $('.menu_tab_slider').slick('refresh');
//     });


 

//   $(".cart-overlay, .reponsive-menu-close").on("click", function() {
//     $('.reponsive-main-menu').find('.has-children').removeClass('is-open');
//     $('.acnav__list').slideUp('fast');
//   });
  
  $('body').on('click','.mob-main-menu ul li a',function(e){
      e.preventDefault();  
      var searchhtml = $('.mobile_responsive_content .search-box').html();
      $.get( $(this).attr('data-pagetemplate') +'?section_id='+ $(this).attr('data-mm_menu'), function( data ) {
        $('.mobile_responsive_content').html($(data).find('.mobile_responsive_content').html());
        $('.mobile_responsive_content .search-box').html(searchhtml);
//         var accordion = new Accordion($('body .reponsive-main-menu'), false);
      });    
    });

  /*** MENU MOBILE ***/
  
  
  /* ------------ Cat-FAQ Accordian Starts ------------ */
  $('body').on('click','.cat-faq-head', function(e){
    $(this).toggleClass('active');
    $(".cat-faq-content").slideToggle();
  });

  $('body').on('click','.maincat-faq-head', function(e){  
    e.preventDefault(); 
    $('.maincat-faq-content').slideUp('100'); 
    $('.maincat-faq-head,.cat-main-faq ul li').removeClass('active'); 
    if(!$(this).parent().find('.maincat-faq-content').is(":visible")){ 
      $(this).parent().find('.maincat-faq-content').slideToggle('500'); 
      $(this).toggleClass('active'); 
      $(this).parent().toggleClass('active'); 
    } 
  });
  /* ------------ Cat-FAQ Accordian Ends ------------ */

  

  /* ------------ Pro Thumb Slider Starts ------------ */

  $('.pro-thumb-slider').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    fade: false,
    asNavFor: '.pro-additional-slider',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          dots: false,
          arrows: true
        }
      }
    ]
  });
  $('.pro-additional-slider').slick({
    lazyLoad: 'ondemand',
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.pro-thumb-slider',
    dots: false,
    focusOnSelect: true,
    infinite: true,
    arrows: true,
    vertical: true,
  });

  /* ------------ CPro Thumb Slider Ends ------------ */

 
  /* ------------ 4 Products Slider Starts ------------ */


  /* ------------ 4 Products Slider Ends ------------ */

  /* ------------ 2 Products Slider Starts ------------ */
  $('.two-product-slider').slick({
    infinite: true,
    centerMode: false,
    slidesToShow: 2,
    slidesToScroll: 1
  });
  /* ------------ 2 Products Slider Ends ------------ */

  //FLASE SALE
    $('.flash_sale_sl_old').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      responsive: [
      {
        breakpoint: 851,
        settings: {
          slidesToShow: 2,
          autoplay:true,
          autoplaySpeed:3000,
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          autoplay:true,
          autoplaySpeed:3000,
        }
      }
    ]
    });

    $('.flash_sale_sl_new').slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          autoplay:true,
          autoplaySpeed:3000,
        }
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          autoplay:true,
          autoplaySpeed:3000,
        }
      }
    ]
    });
  //FLASE SALE

  /*custom select script start here*/
  /*    Reference: http://jsfiddle.net/BB3JK/47/    */

  function create_custom_dropdowns() {
    $('select.custome-select').each(function(i, select) {
      if (!$(this).next().hasClass('dropdown')) {
        $(this).after('<div class="dropdown ' + ($(this).attr('class') || '') + '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>');
        var dropdown = $(this).next();
        var options = $(select).find('option');
        var selected = $(this).find('option:selected');
        dropdown.find('.current').html(selected.data('display-text') || selected.text());
        options.each(function(j, o) {
          var display = $(o).data('display-text') || '';
          dropdown.find('ul').append('<li class="option ' + ($(o).is(':selected') ? 'selected' : '') + '" data-value="' + $(o).val() + '" data-display-text="' + display + '" data-collectionSortby>' + $(o).text() + '</li>');
        });
      }
    });
    $('select.custome-select').on('change', function(e){
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    })
  }

  // Event listeners

  // Open/close
  $(document).on('click', '.dropdown', function(event) {
    $('.dropdown').not($(this)).removeClass('open');
    $(this).toggleClass('open');
    if ($(this).hasClass('open')) {
      $(this).find('.option').attr('tabindex', 0);
      $(this).find('.selected').focus();
    } else {
      $(this).find('.option').removeAttr('tabindex');
      $(this).focus();
    }
  });
  // Close when clicking outside
  $(document).on('click', function(event) {
    if ($(event.target).closest('.dropdown').length === 0) {
      $('.dropdown').removeClass('open');
      $('.dropdown .option').removeAttr('tabindex');
    }
    event.stopPropagation();
  });
  // Option click
  $(document).on('click', '.dropdown .option', function(event) {
    $(this).closest('.list').find('.selected').removeClass('selected');
    $(this).addClass('selected');
    var text = $(this).data('display-text') || $(this).text();
    $(this).closest('.dropdown').find('.current').text(text);
    $(this).closest('.dropdown').prev('select').val($(this).data('value')).trigger('change');
  });

  // Keyboard events
  $(document).on('keydown', '.dropdown', function(event) {
    var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
    // Space or Enter
    if (event.keyCode == 32 || event.keyCode == 13) {
      if ($(this).hasClass('open')) {
        focused_option.trigger('click');
      } else {
        $(this).trigger('click');
      }
      return false;
      // Down
    } else if (event.keyCode == 40) {
      if (!$(this).hasClass('open')) {
        $(this).trigger('click');
      } else {
        focused_option.next().focus();
      }
      return false;
      // Up
    } else if (event.keyCode == 38) {
      if (!$(this).hasClass('open')) {
        $(this).trigger('click');
      } else {
        var focused_option = $($(this).find('.list .option:focus')[0] || $(this).find('.list .option.selected')[0]);
        focused_option.prev().focus();
      }
      return false;
      // Esc
    } else if (event.keyCode == 27) {
      if ($(this).hasClass('open')) {
        $(this).trigger('click');
      }
      return false;
    }
  });

  create_custom_dropdowns();
var cart_open = 0;
  /*add_cart**/
  function addToCartSuccess() {
    $.get("/cart?view=mini-cart", function(data) {
      $('body').find('.minicart-dropdown-content#cart').html(data);
      if(!$('.collection_size.active_size').length > 0){
        $('.mini-cart').trigger("click");
      }
      if($('body').hasClass('shop-the-look')){
          $('.sp_look_img.active').addClass('add_to_cart');
          var sp_item = parseInt($('.sp_look_slider .sp_look_img').length);
          var sp_item_add = parseInt($('.sp_look_slider .sp_look_img.add_to_cart').length);
          if(sp_item == sp_item_add){
            $('.sp_inner_btn').addClass('active_btn');
            $('.sp_inner_text').removeClass('active_txt');
          }
        }
    });
    $.getJSON('/cart.js',function(data){
      $('.mini-cart').find('.count').text(data.item_count);
    });
  
    
  }
  function addToCartSuccess_cart() {
    $.get( "/cart?view=cart-full", function( data ) {
      var data_new = $(data).find('.cart-tbl-main').html();
      var shipping = $(data).find('.side-cart-progress-bar').html();
      var sub_total_btn = $(data).find('.sub-total-btn').html();
      var sub_tl_btn = $(data).find('.cm_cart_inner_total').html();
      var install_mob = $(data).find('.instalment_count.mob_only').html();
      var install_desk = $(data).find('.instalment_count.desk_only').html();
      var bag_add_popup = $(data).find('.gift_main').html();
      $('.cart-tbl-main').html(data_new);
      $('.side-cart-progress-bar').html(shipping);
      $('.sub-total-btn').html(sub_total_btn);
      $('.cm_cart_inner_total').html(sub_tl_btn);
      $('.instalment_count.mob_only').html(install_mob);
      $('.instalment_count.desk_only').html(install_desk);
      $('.gift_main').html(bag_add_popup);
      $('.bag_add_popup_gift').removeClass('active');
      
    if ($(window).width() <= 740) {
      $('.item-info').each(function(){
        var objDesctope = $(this).find('.detail-qty-block.desktop').detach().get(0);
        $(this).find('.qty-wrapper.mobile').html(objDesctope);
      });
    }
  });
    $.getJSON('/cart.js',function(data){
      $('.mini-cart').find('.count').text(data.item_count);
      if(data.item_count <= 0){
         $.get( "/cart?view=cart-full", function( data ) {
             $('#shopping-cart').html(data);
         });
      }
    });
  }

  $('body').on('click','.add_cart, .isp_related_product .isp_serp_product_variant, .isp_grid_product .isp_serp_product_variant',function(e){
    e.preventDefault();
    $('.product-varations-options.show').removeClass('show');
    $('.cat-prolist-inner.add').removeClass('add');
    if($(this).closest('.cat-prolist-block').find('.product-varations-options').length){
      $(this).closest('.cat-prolist-block').find('.product-varations-options').toggleClass('show');
      $(this).closest('.cat-prolist-block').find('.cat-prolist-inner').addClass('add');
    }else{
      $(this).parents('.cat-prolist-block').find('.cat-prolist-inner').removeClass('add');
      var form = $(this).closest('form');
      form.find('.product_error').remove();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: form.serialize(),
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          form.find('.product_error').remove();
          form.append('<p class="product_error">SIN STOCK/SOLD OUT</p>').find('.product_error').fadeIn().delay(4000).fadeOut();
        }
      }).done(function( data ) {
        addToCartSuccess();
      }); 
    }
  });

  $('body').on('click','.add_cart_col',function(e){
    e.preventDefault();
    var $this = $(this);
    if($('.cat-prolist-block.current').length){
      var new_url= String($('.cat-prolist-block.current').attr('data-product'));
      var current_size_c = new_url.split('?');
    }
    var form = $(this).closest('form');
    form.find('.product_error').remove();
    $this.parents('.cat-prolist-inner').find('.lm_select_size.current').closest('li').addClass('adding');
    $('.collection_size').find('.lm_select_size.current').find('.size_cart').addClass('adding').removeClass('size_addtocart').find('span').text('Agregando');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.find('.product_error').remove();
        if($(window).width() > 767){
          form.append('<p class="product_error">SIN STOCK/SOLD OUT</p>').find('.product_error').fadeIn().delay(4000).fadeOut(); 
          $this.parents('.cat-prolist-inner').find('.lm_select_size.current').closest('li').removeClass('adding');
          $('.lm_select_size').removeClass('current');
        }else{
          form.find('.pro-size-block-inner').find('.header').append('<p class="product_error">SIN STOCK/SOLD OUT</p>').find('.product_error').fadeIn().delay(4000).fadeOut();
          $('.collection_size').find('.lm_select_size.current').find('.size_cart').addClass('size_addtocart').removeClass('adding').find('span').text('Agregar al carrito');
          $('.lm_select_size').removeClass('current');
        }
      }
    }).done(function( data ) {
      cart_open = 1;
      if($('body').hasClass('template-cart')){
        addToCartSuccess_cart();
      }else{
      addToCartSuccess();
      }
      $('.product-varations-options.show').find('input').prop('checked',false);
      $this.parents('.cat-prolist-inner').find('.lm_select_size.current').closest('li').removeClass('adding').addClass('svg_added');
      $('.collection_size').find('.lm_select_size.current').find('.size_cart').removeClass('adding').addClass('svg_added').find('span').text('Agregado');
      setTimeout(function(){
        if($('.cat-prolist-block.current').length){
          $.get(current_size_c[0]+"?view=size_update", function(data_c) {
            $('.cat-prolist-block.current').find('.mob_size_popup').find('.product-varations-options').html(data_c);
            $('.collection_size.active_size').find('.mob_size_popup').find('.product-varations-options').html(data_c);
          });
          $('.collection_size').find('.lm_select_size.current').find('.size_cart').removeClass('svg_added').hide();
          $('.collection_size.active_size').find('.pro-size-block-inner').find('input').attr('disabled',false);
          $('.collection_size').find('.lm_select_size.current').find('.detail-qty-block-col').show();
        }
        $this.parents('.cat-prolist-inner').find('.lm_select_size.current').closest('li').removeClass('svg_added');
        $('.lm_select_size').removeClass('current');
      },1000);
    }); 
  });
$('body').on('click','.bag_add_popup.active .swatch-element .size_addtocart,.bag_add_popup_gift.active .swatch-element .size_addtocart',function(e){
    e.preventDefault();
    var $this = $(this).closest('.swatch-element');
    $('.collection_size.active_size').find('.lm_select_size').removeClass('current');
     $this.find('.lm_select_size').addClass('current');
    if($('.bag_add_popup.active').length){
      var new_url= String($('.bolsa-de-regalo').attr('data-product'));
      var current_size_c = new_url.split('?');
    }else{
      var new_url= String($('.surprise-gift').attr('data-product'));
      var current_size_c = new_url.split('?');
    }
    var form = $(this).closest('.pro-size-block-inner');
    form.find('.product_error').remove();
    $this.addClass('adding');
    $('.collection_size.active_size').find('.lm_select_size.current').find('.size_cart').addClass('adding').removeClass('size_addtocart').find('span').text('Agregando');
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data:{
        id: $this.attr('var-id'),
        quantity: 1,
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.find('.product_error').remove();
          form.append('<p class="product_error">SIN STOCK/SOLD OUT</p>').find('.product_error').fadeIn().delay(4000).fadeOut(); 
          $('.collection_size.active_size').find('.lm_select_size.current').find('.size_cart').addClass('size_addtocart').removeClass('adding').find('span').text('Agregar al carrito');
          $this.parents('.collection_size.active_size').find('.lm_select_size.current').closest('li').removeClass('adding');
          $('.lm_select_size').removeClass('current');        
      }
    }).done(function( data ) {
      cart_open = 1;
       addToCartSuccess_cart();
      $('.product-varations-options.show').find('input').prop('checked',false);
      $this.parents('.cat-prolist-inner').find('.lm_select_size.current').closest('li').removeClass('adding').addClass('svg_added');
      $('.collection_size.active_size').find('.lm_select_size.current').find('.size_cart').removeClass('adding').addClass('svg_added').find('span').text('Agregado');
      setTimeout(function(){
        if($('.bag_add_popup.active').length || $('.bag_add_popup_gift.active').length){
          $.get(current_size_c[0]+"?view=cart-size-update", function(data_c) {
            if($('.bag_add_popup.active').length){
            $('.bag_add_popup.active').find('.mob_size_popup').find('.product-varations-options').html(data_c);
            }else{
              $('.bag_add_popup_gift.active').find('.mob_size_popup').find('.product-varations-options').html(data_c);
            }
          });
          $('.collection_size').find('.lm_select_size.current').find('.size_cart').removeClass('svg_added').hide();
          $('.collection_size.active_size').find('.pro-size-block-inner').find('input').attr('disabled',false);
          $('.collection_size').find('.lm_select_size.current').find('.detail-qty-block-col-cart').show();
        }
        $this.parents('.cat-prolist-inner').find('.lm_select_size.current').closest('li').removeClass('svg_added');
        $('.lm_select_size').removeClass('current');
      },1000);
    }); 
  });
  $('body').on('click','#add-to-cart',function(e){
    $('.size-msg').remove();
    if($(this).hasClass('size-select')){
      $(this).after('<div class="size-msg">select size</div>');
      $(this).addClass('size-not-selected').find('span').text('Seleccione una talla');
      if($('.pro-detile-btn-wrapper').hasClass('sticky_filter')){
        $('html, body').animate({
          scrollTop: $("#product-details-block").offset().top
        }, 1000);
      }
    }else{
      e.preventDefault();
      var btn = $(this);
      var form = $(this).closest('form');
      btn.attr('disabled', 'disabled');
      btn.addClass('loading').removeClass('added');
      form.find('.product_error').remove();
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: form.serialize(),
        dataType: 'json',
        error: function(jqXHR, textStatus, errorThrown){
          var response = $.parseJSON(jqXHR.responseText);
          form.find('.product_error').remove();
          form.append('<p class="product_error">SIN STOCK/SOLD OUT</p>').find('.product_error').fadeIn().delay(4000).fadeOut();
          btn.removeClass('loading').attr('disabled', 'disabled').find('span').text('Sin stock');
        }
      }).done(function( data ) {
        btn.removeClass('loading').removeAttr('disabled').addClass('added').find('span').text('Añadido al carrito');
        setTimeout(function(){
        addToCartSuccess();
          },50);
      });
    }
  });

  $('body').on("click",".cart-pro-qtyblock .btn-qty",function(e){
    e.preventDefault();
    var $this = $(this);
    var cur_item = $this.closest('.product-list-block').attr('data-handle');
    var cur_item_grid = $('.cat-prolist-block[data-handle="'+cur_item+'"]');
    var new_url = String(cur_item_grid.attr('data-product'));
    var current_size_url = new_url.split('?');
    var val = parseInt($this.parents('.detail-qty-block').find('input').val());
    if($(this).hasClass('quantity-increment')){
      val= val+1;
    }else if($(this).hasClass('quantity-decrement')){
        val = val - 1;
    }
    $(this).parents('.detail-qty-block').find('input').val(val);
    var id = $(this).parents('.detail-qty-block').find('input').data('item_id');
    if(id){
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/cart/update.js",
        data: "updates["+id+"]="+val,
        async: false
      }).done(function(){
        addToCartSuccess();
        $.get(current_size_url[0]+"?view=size_update", function(data) {
          cur_item_grid.find('.product-varations-options').html(data);
        });
      });
    }
  });
  
 $('body').on("click",".detail-qty-block-col .btn-qty",function(e){
    e.preventDefault();
    var $this = $(this);
    var val = parseInt($(this).parents('.detail-qty-block-col').find('input').val());
    
    if($('.bag_add_popup.active').length || $('.bag_add_popup_gift.active').length){
      if($('.bag_add_popup.active').length){
      var new_url1= String($('.bolsa-de-regalo').attr('data-product'));  
      }else{
      var new_url1= String($('.surprise-gift').attr('data-product'));
      }
      var current_size_c1 = new_url1.split('?');
    }else{
      var new_url = String($('.cat-prolist-block.current').attr('data-product'));	
    var current_size = new_url.split('?');
    }
    
    if($(this).hasClass('quantity-increment')){
      val= val+1;
    }else if($(this).hasClass('quantity-decrement')){
        val = val - 1;
    }
    $(this).parents('.detail-qty-block-col').find('input').val(val);
    var id = $(this).parents('.detail-qty-block-col').find('input').data('item_id');
    if(id){
      $.ajax({
        type: "POST",
        dataType: "json",
        url: "/cart/update.js",
        data: "updates["+id+"]="+val,
        async: false
      }).done(function(){
        cart_open = 1;
        addToCartSuccess();
        
        if(($('.bag_add_popup.active').length || $('.bag_add_popup_gift.active').length) || $('.bag_add_popup_gift.active').length){
          $.get(current_size_c1[0]+"?view=cart-size-update", function(data) {
            console.log('data',data)
            if($('.bag_add_popup.active').length){
            $('.bag_add_popup.active').find('.mob_size_popup').find('.product-varations-options').html(data);
            }else{
              $('.bag_add_popup_gift.active').find('.mob_size_popup').find('.product-varations-options').html(data);
            }
            // $('.collection_size.active_size').find('.mob_size_popup').find('.product-varations-options').html(data)
          });
          addToCartSuccess_cart();
        }else{
          $.get(current_size[0]+"?view=size_update", function(data) {
          $('.cat-prolist-block.current').find('.mob_size_popup').find('.product-varations-options').html(data);
          $('.collection_size.active_size').find('.mob_size_popup').find('.product-varations-options').html(data)
        });
        }
      });
    }
  });

  $('body').on("click",".cart_remove",function(e){
    e.preventDefault();
    var id = $(this).data('item_id');
    $.ajax({
      type: "POST",
      dataType: "json",
      url: "/cart/update.js",
      data: "updates["+id+"]=0",
      async: false
    }).done(function(){
      addToCartSuccess();
    });
  }); 

  $('body').on('click', '.qty-wrapper-inc .btn-qty',function(e){
    e.preventDefault();
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('quantity-increment')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
//     if(ip==0) {
//       return false;
//     }
    input.val(ip);

    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
      success: function(){
        addToCartSuccess_cart();
      }
    });

  });

  $('body').on("click","#shopping-cart .remove-item",function(e){
    e.preventDefault();
    var id = $(this).data('id');
    $.ajax({
      type: "POST",
      dataType: "json",
      url: "/cart/update.js",
      data: "updates["+id+"]=0",
      async: false
    }).done(function(){
      addToCartSuccess_cart();
    });
  }); 


  /*** SIZE VAR ***/
  $('body').on('click', '.cm_size_btn',function(e){
    e.preventDefault();
    $('.collection_size').html('');
    $(this).closest('.cat-prolist-block').addClass('current');
    var data_popup =  $(this).closest('.cat-prolist-inner').find('.mob_size_popup').clone();
    $('.collection_size').html(data_popup).addClass('active_size');
    $('.pr_overlay').addClass('active_size');
    $('body').addClass('overflow-hidden');
  });
  $('body').on('click', '.pr_close_icon',function(e){
    e.preventDefault();
    $('.cat-prolist-block').removeClass('current');
    $('.collection_size').html('').removeClass('active_size');
    $('.pr_overlay').removeClass('active_size');
    $('body').removeClass('overflow-hidden');
    if(cart_open == 1){
      $('.mini-cart').trigger("click"); 
    }
    cart_open = 0;
  });
   $('body').on('click', '.pr_close_icon_gift,.bag_add_overlay',function(e){
    e.preventDefault();
     $('.bag_add_popup').removeClass('active');
     $('.bag_add_popup_gift').removeClass('active');
  });
  $('body').on('click', '.pr_overlay',function(e){
    e.preventDefault();
    $('.cat-prolist-block').removeClass('current');
    $(this).removeClass('active_size');
    $('.collection_size').html('').removeClass('active_size');
    $('body').removeClass('overflow-hidden');
    if(cart_open == 1){
      $('.mini-cart').trigger("click"); 
    }
    cart_open = 0;
  });

  // Load more
  var pInfScrLoading = false;
  var pInfScrDelay = 100;

  function pInfScrExecute() {
    var elm = document.getElementById('more-collection');
    var loadingImage,loadingmore;
    pInfScrNode = $('.more').last();
    pInfScrmore = $('.show_more').last();
    pInfScrURL = $('.more a').last().attr("href");
    if(!pInfScrLoading && pInfScrNode.length > 0  && pInfScrNode.css('display') != 'none' ) {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('<img src="https://cdn.shopify.com/s/files/1/0555/6820/3925/files/loading.png?v=1620381339" />');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
          pInfScrmore.hide();
        },
        success: function(data) {
          pInfScrNode.next().remove();
          pInfScrmore.next().remove();
          var filteredData = $(data).find(".col-product").html();
          var paginate = $(data).find(".productcount").html();
          $('.col-product').append(filteredData);
          $('.productcount').html(paginate);
          loadingImage.remove();
          pInfScrLoading = false;
          custom_link_refresh();
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
        },
        dataType: "html"
      });

    }
  }

  $('body').on('click', '.show_more',function(){
    if(document.getElementById("more-collection")){
      $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
      var elm = document.getElementById('more-collection');
      pInfScrDelay = 100;
    }
  });

  //  end load more

  $('body').on('click','.cm-menu-tab-btn ul li a', function(){
    $('.cm-menu-tab-btn ul li a').removeClass('is_active');
    $(this).addClass('is_active');
    var active_tab = $(this).attr('data-tab');
    $('.multi_tab').hide().removeClass('is_active_tab');
    $('.multi_tab.'+active_tab).show().addClass('is_active_tab');
  });

  /* Filter Showmore Showless Script Starts */
  $('.left-inner .filter-block').each(function(){
    var $ps = $(this).find('.coll-filter').find("a");
    if($(this).find('.coll-filter').find("a").length > 5){
      $(this).find('.coll-filter').find(".readmore").show();
      $(this).parent('.coll-filter').find(".readless").hide();
    }
    $ps.slice(5).hide();
    $('.filter-box.filter-block.custom_filter.Tamaño').find('.readmore').trigger('click');
  });
  $('body').on('click','.filter-block .readless',function(){
    var $ps = $(this).parent('.coll-filter').find("a");
    $ps.slice(5).hide();
    $(this).parent('.coll-filter').find(".readless").hide();
    $(this).parent('.coll-filter').find(".readmore").show();
  });
  $('body').on('click','.filter-block .readmore', function(){
    $(this).parent('.coll-filter').find("a").show();
    $(this).parent('.coll-filter').find(".readless").show();
    $(this).parent('.coll-filter').find(".readmore").hide();
  });
  /* Filter Showmore Showless Script Ends */

  'use strict';
  var c, currentScrollTop = 0,
      navbar = $('header'), cnt_h = 0;

  $(window).scroll(function () {
    var mainheader = $('header').outerHeight();
    var a = $(window).scrollTop();
    var b = navbar.height();

    currentScrollTop = a;
    if (c < currentScrollTop && a > b ) {
      navbar.addClass("scrollUp");
      $('.wrapper').removeClass("isp-scrollUp");
      $(".mobile-filter-block").css("top", 0);
      cnt_h = $(window).scrollTop();
    } else if (c > currentScrollTop && !(a <= b)) {
      if((cnt_h - 0) >=  $(window).scrollTop()){
        navbar.removeClass("scrollUp");
        navbar.addClass("sticky");
        $('.wrapper').addClass("isp-scrollUp");
        $(".mobile-filter-block").css("top", mainheader - 33);
      }
    }
    c = currentScrollTop;
    if ($(window).scrollTop() <= 5 ) {
      $('header').removeClass("scrollUp");
      navbar.removeClass("sticky");
    }

    if($('.pro-detile-btn-wrapper').length > 0){
      if ($(window).width() < 768) {
        var btn = $('.pro-detile-btn-wrapper').offset().top;
        var win = $(window).scrollTop();
        if(win >= btn) {
          $('.pro-detile-btn-wrapper,body').addClass('sticky_filter');
        }else{
          $('.pro-detile-btn-wrapper,body').removeClass('sticky_filter');
        }
      }
    }
    /* if ($(this).scrollTop() > b) {
      $('.mobile-filter-block').addClass("sticky");
    }
    else {
      $('.mobile-filter-block').removeClass("sticky");
      $(".mobile-filter-block").css("top", 0);
    } */
    $('body').css("padding-top", mainheader);
  });

  $('body').on('click','.mob_search_icon',function() { 
    $('.responsive-bottom-block .search-box').slideToggle();
    $(this).toggleClass('active_sc');
    setTimeout(function(){
      var h_height = $('header').outerHeight();
      $('body').css("padding-top", h_height);
    },300);
  });
  
  /* Sticky Header Script Ends */
  $('body').on('click','.filter-talla-lable', function(e){
    e.preventDefault();
    $(".talla-compare, body").addClass("active-filter-pop");
    $('body').find(".minicart-dropdown,.cart-overlay").removeClass('active');
  });

  $.get("/collections/all?view=filter-data", function(data) { 
    var col_data = $(data).find('.talla-compare').html();
    $('.collection_popup').append(col_data); 
  });
  $('body').on('click','.hero-size-search', function(e){
    e.preventDefault();
    $(this).addClass('loading');
    $(".talla-compare, body").addClass("active-filter-pop");
    $('body').find(".minicart-dropdown,.cart-overlay").removeClass('active');
  });

  $('body').on('click','.overlay-filter, .close-pop-fl',function(e){
    e.preventDefault();
    $(".talla-compare, body").removeClass("active-filter-pop");
    $('.hero-size-search').removeClass('loading');
  });
 
  $('body').on('click','.size-guide-open a', function(e){
    e.preventDefault();
    if($('body').hasClass('product-v2_product')){
      $(this).closest('.stlpopup-wrap').find('.size-guide-chart').addClass("active-size-guide");
      $("body").addClass("active-size-guide");
    }else{
      $(".size-guide-chart, body").addClass("active-size-guide");
    }
  });
  $('body').on('click','.size-guide-close, .size-chart-overla', function(e){
    e.preventDefault();
    $(".size-guide-chart, body").removeClass("active-size-guide");
  });
  $('body').on('click','.history-popup', function(e){
    e.preventDefault();
    $(".history-table, body").addClass("active-history");
  });
  $('body').on('click','.close-pop-history, .popup-overlay', function(e){
    e.preventDefault();
    $(".history-table, body").removeClass("active-history");
  });

  $('body').on('click','.table-change-tab li a', function(){
    var cur = $(this).attr('data-href');
    if($('body').hasClass('product-v2_product')){
      $(this).closest('.stlpopup-wrap').find('.table-change-tab li a').removeClass('active');
      $(this).addClass('active');
      $(this).closest('.stlpopup-wrap').find('.size-table').removeClass('active');
      $(this).closest('.stlpopup-wrap').find('#'+cur).addClass('active');
    }else{
      $('.table-change-tab li a').removeClass('active');
      $(this).addClass('active');
      $('.size-table').removeClass('active');
      $('#'+cur).addClass('active');
    }
  });


  $('body').on('click','.account-navigation ul li',function(){
    var tab_id = $(this).attr('data-tab');
    $('.account-navigation ul li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })

  $('body').on('click','.btn-invite-click', function(e){
    e.preventDefault();
    $(".invite-fd-text").slideUp('fast');
    $(".invite-fd-form").slideDown('fast');
    $(".invite-friend").addClass('form-open');
  });

  $('.collection-grid-inner').slick({
    arrows:true,
    dots:false,
    infinite:true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  $('.home_cat_slider').slick({
    arrows:true,
    dots:false,
    infinite:true,
    slidesToShow: 6,
    touchThreshold: 100,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });


  $("body").on("click",".discount_checkout,.top_checkout",function(e){
    $('.checkout_btn').trigger('click');
  });
  $('body').on('click','.crt-chkout-btn,.checkout_btn', function(){
    $('.crt-chkout-btn,.checkout_btn').addClass('loading');
  });

  size_call();
  if(jQuery('.product-v2_product #stl-cont .error-popup').length){
    jQuery('.product-v2_product #stl-cont .error-popup').css('opacity',1);
  }
  $('body').on('change','.is_product_page .single-option-selector.size',function(){
    if($(this).val() == ''){
      var pid = $(this).closest('.is_product_page');
      remove_all_atc(pid);
    }
  });
  
  $('body').on('click','.close-error, .close_nd_animate', function(){
    $('.error-popup').hide();
    $('body').removeClass('select_size_popup');
    $('.stlpopup-wrap.active').find('.cart-button').prop('disabled', false);
    $('.stlpopup-wrap.active .sizcart-col.product-opt, body.product .productInfo .select_size, body.product .cm_add_bag_btns .selector-wrapper.is-size, body.product .cm_add_bag_btns .drop').addClass('pulse');
    setTimeout(function(){
      $('.stlpopup-wrap .sizcart-col.product-opt, body.product .productInfo .select_size, body.product .cm_add_bag_btns .selector-wrapper.is-size, body.product .cm_add_bag_btns .drop').removeClass('pulse');
    },1000);
  });
  $('.single-option-selector').change(function(){
    if($(this).val() == '' ){
      $('body .stlpopup-wrap.active').find('input[name="variant_id"]').val('');
    }
  });
  
  $('body').on('click','.cart-button', function(e){
    e.preventDefault();
    var t = $(this);
    t.attr('disabled','disabled');
    var vid=[];
    var v = $('body .stlpopup-wrap.active').find('input[name="variant_id"]').val();
    if(v != '' && v != null && v != undefined){
      vid.push(v);
    }
    if(vid.length == 0){
//       $('.error-popup').show();
//       $('body').addClass('select_size_popup');
      ('body .stlpopup-wrap.active').find('.cart-button').attr('disabled', 'disabled').addClass('disabled');
      return false;
    }
    else{
      $('.error-popup').hide();
      $('body').removeClass('select_size_popup');
      let iterations = vid.length;
      var data = [];
      for (var i of vid.reverse()) {
        var items = {};
        items.id = i;
        items.quantity = 1;
        data.push(items);
      }
      $.post('/cart/add.js', {
        items: data
      }, function(pro){
        t.removeAttr('disabled');
        $('#stl-cont').attr('data-addcnt',(parseInt($('#stl-cont').attr('data-addcnt')) + 1));
        $('body .stlpopup-wrap').find('.cart-count').text($('#stl-cont').attr('data-addcnt'));
        addToCartSuccess();
      },'JSON').fail(function(response) {
        t.removeAttr('disabled');
        alert('Something went wrong...');
      })
    }
  });
  
  $('body').on('click','.pro_url',function(e){
    e.preventDefault();
    var a= $(this);
    var u = a.attr('href');
    var old_select = $('.sp_look_img.active').parent('.sp_sl_item').attr('data-product-handle');
    if($('body').hasClass('shop-the-look')){
      var New_url = u+'?view=product-swatch-shop';
    }else{
     var New_url = u+'?view=product-swatch';      
    }
    $.ajax({
      url: New_url,
      type: 'get',
      success: function(p){
        a.closest('.wrapper_inner').html(p);
        setTimeout(function(){
          $('.pro-thumb-slider').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            fade: false,
            asNavFor: '.pro-additional-slider',
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  dots: true,
                  arrows: false
                }
              }
            ]
          });
          $('.pro-additional-slider').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.pro-thumb-slider',
            dots: false,
            focusOnSelect: true,
            infinite: true,
            arrows: true,
            vertical: true,
          });
        },500);
        if($('body').hasClass('shop-the-look')){
         sp_look_slider(); 
        }else{
          var cur_product = window.location.href;
          var pro_handle = cur_product.split('/products/');
          var new_handle = u.split('/products/');
          var handle_new = new_handle[1].split('?');
          window.history.pushState('', null, pro_handle[0]+'/products/'+handle_new[0]);
        }
        setTimeout(function(){
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        },1000);
      },
      error: function(e){
        a.remove(); 
      }
    });
  });

 $('body').on('click','.pro_url_shop',function(e){
   $('.sp_look_img').removeClass('active');
    e.preventDefault();
    var a= $(this);
    var u = a.attr('href');  
    $.ajax({
      url: u+'?view=shop-look-swatch',
      type: 'get',
      success: function(p){
        var all_data = $(p).find('.product-info-sec-main').html();
        a.closest('.wrapper_inner').find('.product-info-sec-main').html(all_data);
        setTimeout(function(){
          $('.pro-thumb-slider').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            fade: false,
            asNavFor: '.pro-additional-slider',
            responsive: [
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 1,
                  dots: true,
                  arrows: false
                }
              }
            ]
          });
          $('.pro-additional-slider').slick({
            lazyLoad: 'ondemand',
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.pro-thumb-slider',
            dots: false,
            focusOnSelect: true,
            infinite: true,
            arrows: true,
            vertical: true,
          });
          
        },500);
        a.parent('.sp_look_img').addClass('active');
        sp_item_header(); 
        related();
        setTimeout(function(){
          var api = new Yotpo.API(yotpo);
          api.refreshWidgets();
          document.dispatchEvent(new CustomEvent("swym:collections-loaded")); 
        },1000);
      },
      error: function(e){
        a.remove(); 
      }
    });
  });

  // cart expire countdown
    var timer2 = '{{ settings.urgency_bar_time }}';
    var interval = setInterval(function() {
    
    var timer = timer2.split(':');
    //by parsing integer, I avoid all extra string processing
    var minutes = parseInt(timer[0], 10);
    var seconds = parseInt(timer[1], 10);
    --seconds;
    minutes = (seconds < 0) ? --minutes : minutes;
    if (minutes < 0) clearInterval(interval);
    if (minutes < 0){$('.cart_expire_wrapper').remove();}
    seconds = (seconds < 0) ? 59 : seconds;
    seconds = (seconds < 10) ? '0' + seconds : seconds;
    //minutes = (minutes < 10) ?  minutes : minutes;
    $('.cart_expire_countdown_time').html(minutes + ':' + seconds);
    timer2 = minutes + ':' + seconds;
    }, 1000);

  $('body').on('click','.fast-simon-form button',function() { 
    $("input.fast-autocomplete").toggleClass('active_search');
  });
      
});


$(window).on('load resize orientationchange', function () {
  $('.pt_tb_wp').each(function () {
    var $pt_tb_wp = $(this);
    /* Initializes a slick carousel only on mobile screens */
    // slick on mobile
    if ($(window).width() > 767) {
      if ($pt_tb_wp.hasClass('slick-initialized')) {
        $pt_tb_wp.slick('unslick');
      }
    }
    else {
      if (!$pt_tb_wp.hasClass('slick-initialized')) {
        $pt_tb_wp.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          infinite: false,
          arrows: false,
          dots: true,
          touchThreshold: 100,
          swipeToSlide: true,
          waitForAnimate: false
        });
      }
    }
  });
});

/* Responsive Toggle Footer Starts */
$(window).on("load", function (e) {
  $('.filter-box.filter-block.custom_filter.Tamaño').find('.readmore').trigger('click');
  /*script here*/
  $('.crt-chkout-btn').removeClass('loading');
  $('body').on('click','.footer-col span', function (e) {
    if ($(window).width() <= 991) {
      $(".footer-col span").removeClass("active");
      $(".footer-links-content").slideUp();
      if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
      }
    }
  });  

//  $('.mobile-filter-block').addClass('active');
});


/* ISP Mobile pop-up input */
$('body').on('focusout click','#mobile_dropdown_input',function(){


  /* Remove all narrow inputs over the search boxs */
  inputsToRemove = document.querySelectorAll(
    '[action="/pages/search-results"] input[name="narrow"]'
  );
  Array.prototype.forEach.call(inputsToRemove, function (node) {
    node.parentNode.removeChild(node);
  });


  /* Search Results inputs Narrow */
  for (const form of [...document.querySelectorAll("#mobile_dropdown_input")]) {
    form.insertAdjacentHTML(
      "beforeend",
      `<input type="hidden" name="narrow" value='${JSON.stringify([["Vendor",site]])}'>`
    );
  }
  
  if($('#mobile_dropdown_input').val() != '' && $('#mobile_dropdown_input').val() != null){
    $('#mobile_dropdown_input').closest('form').submit();
  }else{
    $('span.mobile_dropdown_btn.close_btn').trigger('click');
  }
});

$(window).on('scroll', function(){
  if($(this).scrollTop() > 1){
    $('.product-v2_product .stlpopup-wrap.active .stlpopup-footer').addClass('unset_position');
  }else{
    $('.product-v2_product .stlpopup-wrap.active .stlpopup-footer').removeClass('unset_position');
  }
});


var slideWrapper = $(".hero_slider"),
    iframes = slideWrapper.find('.embed-player'),
    lazyImages = slideWrapper.find('.slide-image'),
    lazyCounter = 0;
function postMessageToPlayer(player, command){
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("data-slide-type");
  player = currentSlide.find("iframe").get(0);
  startTime = currentSlide.data("video-start");
  //     console.log(slideType + ' ' + control);
  if (slideType === "vimeo") {
    switch (control) {
      case "play":
        if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
          currentSlide.addClass('started');
          postMessageToPlayer(player, {
            "method": "setCurrentTime",
            "value" : startTime
          });
        }
        postMessageToPlayer(player, {
          "method": "play",
          "value" : 1
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "method": "pause",
          "value": 1
        });
        break;
    }
  } else if (slideType === "youtube") {
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          "event": "command"
        });
        postMessageToPlayer(player, {
          "event": "command",
          "func": "playVideo"
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          "event": "command",
          "func": "pauseVideo"
        });
        break;
    }
  } else if (slideType === "video") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

// Resize player
function resizePlayer(iframes, ratio) {
  if (!iframes[0]) return;
  var win = $(".hero_slider"),
      width = win.width(),
      playerWidth,
      height = win.height(),
      playerHeight,
      ratio = ratio || 16/9;

  iframes.each(function(){
    var current = $(this);
    if (width / ratio < height) {
      playerWidth = Math.ceil(height * ratio);
      current.width(playerWidth).height(height).css({
        left: (width - playerWidth) / 2,
        top: 0
      });
    } else {
      playerHeight = Math.ceil(width / ratio);
      current.width(width).height(playerHeight).css({
        left: 0,
        top: (height - playerHeight) / 2
      });
    }
  });
}

// DOM Ready
$(function() {
  // Initialize
  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      playPauseVideo(slick,"play");
    }, 1000);
    resizePlayer(iframes, 16/9);
  });
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"play");
  });
  slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
    lazyCounter++;
    if (lazyCounter === lazyImages.length){
      lazyImages.addClass('show');
      // slideWrapper.slick("slickPlay");
    }
  });
  //start the slider
});
// Resize event
$(window).on("resize.slickVideoPlayer", function(){  
  resizePlayer(iframes, 16/9);
});

$(function () {
  $('.hero_marquee').infiniteslide({
      speed: 50,
      pauseonhover: false,
      clone: 5,
      direction: 'left'
  });
});